const TENANT_STORAGE_KEY = 'assetcast_selected_tenant';

let currentTenant: string | null = null;

if (typeof window !== 'undefined') {
  currentTenant = sessionStorage.getItem(TENANT_STORAGE_KEY);
}

export const tenantStore = {
  getTenant(): string | null {
    return currentTenant;
  },

  setTenant(tenant: string | null): void {
    currentTenant = tenant;
    if (typeof window !== 'undefined') {
      if (tenant) {
        sessionStorage.setItem(TENANT_STORAGE_KEY, tenant);
      } else {
        sessionStorage.removeItem(TENANT_STORAGE_KEY);
      }
    }
  },

  clearTenant(): void {
    currentTenant = null;
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(TENANT_STORAGE_KEY);
    }
  },
};
